/**
 * Reducers for the New User app
 */

import { combineReducers } from 'redux-immutable';
import { Map } from 'immutable';

import {
    BROWSER_DETAILS_KEY,
    browserDetailsReducer,
} from 'phoenix2/state/browser-details/reducers';
import {
    CONFIG_PARAMETERS_KEY,
    configParametersReducer,
} from 'phoenix2/state/config-params/reducers';
import { VIEWS_KEY, viewsReducer } from 'phoenix2/state/views/reducers';
import { ALERT_KEY, alertReducer } from 'phoenix2/state/alert/reducers';
import { MESSAGES_KEY, messagesReducer } from 'phoenix2/state/messages/reducers';
import { FEATURE_FLAGS_KEY, featureFlagsReducer } from 'phoenix2/state/feature-flags/reducers';
import { APPSTATE_KEY, appStateReducer } from '../appstate/reducers';
import { WAIT_KEY, waitReducer } from '../wait/reducers';
import {
    RESET_PASSWORD_HANDOUT_ERROR,
    SET_PASSWORD,
    SET_NEW_PASSWORD,
    SET_PASSWORD_HANDOUT_ERROR,
    SET_PASSWORD_HANDOUT_THROTTLED,
    SET_USERNAME,
} from './actions';
import { VIEW_STATES_KEY, viewStatesReducer } from '../viewstates/reducers';

export const NEW_USER_KEY = 'newUser';

const appReducer = combineReducers({
    [BROWSER_DETAILS_KEY]: browserDetailsReducer,
    [CONFIG_PARAMETERS_KEY]: configParametersReducer,
    [VIEWS_KEY]: viewsReducer,
    [ALERT_KEY]: alertReducer,
    [MESSAGES_KEY]: messagesReducer,
    [APPSTATE_KEY]: appStateReducer,
    [WAIT_KEY]: waitReducer,
    [NEW_USER_KEY]: newUserReducer,
    [FEATURE_FLAGS_KEY]: featureFlagsReducer,
    [VIEW_STATES_KEY]: viewStatesReducer,
});

export const rootReducer = appReducer;

const initState = Map({
    // Stores the user's new password, to match against when they confirm it
    password: null,

    // Users personal details
    firstName: null,
    lastName: null,
    username: null,
    dateOfBirth: null,
    // Whether there was a validation error in submission of a new password
    // request - wrong invite code, DOB, expired invite code
    error: false,
    // Specific error for too many attempts. Value can be ignored if error is false
    errorThrottled: false,
});

export function newUserReducer(state = initState, action) {
    switch (action.type) {
        case SET_NEW_PASSWORD:
            return Map({
                password: action.password,
                firstName: action.firstName,
                lastName: action.lastName,
                username: action.username,
                error: false,
            });
        case SET_USERNAME:
            return Map({
                firstName: action.firstName,
                lastName: action.lastName,
                dateOfBirth: action.dateOfBirth,
                username: action.username,
                error: false,
            });
        case SET_PASSWORD:
            return state.set('password', action.password);
        case SET_PASSWORD_HANDOUT_ERROR:
            return state.merge({
                error: true,
                errorThrottled: false,
            });
        case SET_PASSWORD_HANDOUT_THROTTLED:
            return state.merge({
                error: true,
                errorThrottled: true,
            });
        case RESET_PASSWORD_HANDOUT_ERROR:
            return state.merge({
                error: false,
                errorThrottled: false,
            });
    }
    return state;
}
